/* @jsx h */
import { h, render } from "preact";
import App from "./App";

render(<App />, document.querySelector(".m2-extension__campaign-checklist"));
